module.exports = __webpack_public_path__ + "static/img/jzgl_p2.e99ccdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/jzgl_p2.png
// module id = B2dv
// module chunks = 19